/* Lagom theme: mission module, ported from the prototype's main.js. Loads only when its section is on the page. */
(function () {
  'use strict';
  var L = window.Lagom; if (!L || !L.q) { return; }
  var q = L.q, qa = L.qa, motionOff = L.motionOff;
  /* ---------- 2r. The manifesto book ----------
     "Read our manifesto": the closed book rises from the button to the middle of the screen (400 ms), then the cover
     turns open round its left edge (900 ms): tablet/desktop show the whole manifesto on the spread (the inside of the
     cover is the left page), phones get one text page that turns with a swipe (below) while the cover swings off to the left. Closing: the cover swings shut (700 ms), the book
     sinks back to the button, the backdrop fades. The script only toggles classes; CSS transitions do the motion.
     Native <dialog>: focus on the close button, Tab kept inside, Esc / backdrop / x close, the page is locked, focus
     goes back to the button. Reduced motion / ?capture=1: no 3D, the text page fades in and out.
     The book images (data-* on the dialog) load on the first hover/focus/press of the button, never with the page. */
  (function () {
    var dlg = q('[data-manifesto]');
    if (!dlg || !dlg.showModal) { return; }
    var lift = q('[data-book-lift]', dlg), scroller = q('[data-manifesto-paper]', dlg), closeBtn = q('[data-manifesto-close]', dlg);
    var shade = q('[data-book-shade]', dlg), shine = q('[data-book-shine]', dlg);
    var opener = null, busy = false, timers = [], loaded = null;
    var flows = qa('[data-manifesto-flow]', dlg), wide = window.matchMedia('(min-width: 768px)');
    /* Spread: the biggest font size (15 -> 10px) at which the text fits in the two columns. Once per open / resize. */
    function fit() {
      var main = flows[0], fs = 15;
      flows.forEach(function (f) { f.style.fontSize = ''; });
      if (!wide.matches || !main) { return; }
      while (fs > 10 && main.scrollWidth > main.clientWidth + 1) { fs -= 0.5; flows.forEach(function (f) { f.style.fontSize = fs + 'px'; }); }
    }
    window.addEventListener('resize', function () { if (dlg.open) { fit(); } });
    function later(fn, ms) { timers.push(window.setTimeout(fn, ms)); }
    function clearTimers() { timers.forEach(clearTimeout); timers = []; [shade, shine].forEach(function (el) { if (el) { el.getAnimations().forEach(function (a) { a.cancel(); }); } }); }
    function preload() {
      if (loaded) { return loaded; }
      var sm = window.matchMedia('(max-width: 767px)').matches;
      function src(k) { return (sm && dlg.getAttribute('data-' + k + '-sm')) || dlg.getAttribute('data-' + k); }
      ['cover', 'page', 'edge'].forEach(function (k) { dlg.style.setProperty('--book-' + k, 'url("' + src(k) + '")'); });
      loaded = new Promise(function (res) { var i = new Image(); i.onload = i.onerror = res; i.src = src('cover'); if (i.decode) { i.decode().then(res, res); } });
      return loaded;
    }
    /* Where the button is, relative to the middle of the screen (the book starts there, at 60 %). */
    function fromButton() {
      var r = opener && opener.getBoundingClientRect ? opener.getBoundingClientRect() : null;
      if (!r || (!r.width && !r.height)) { return 'translate(0px,' + Math.round(innerHeight * 0.4) + 'px) scale(.6)'; }
      return 'translate(' + Math.round(r.left + r.width / 2 - innerWidth / 2) + 'px,' + Math.round(r.top + r.height / 2 - innerHeight / 2) + 'px) scale(.6)';
    }
    function jump(el, props) {   /* set styles with no transition */
      el.style.transition = 'none'; Object.keys(props).forEach(function (k) { el.style[k] = props[k]; });
      void el.offsetWidth; el.style.transition = '';
    }
    function open(instant, from) {
      if (busy || dlg.open) { return; }
      busy = true; clearTimers();
      document.dispatchEvent(new CustomEvent('lagom:panel', { detail: 'manifesto' }));
      opener = from || document.activeElement;   /* the button that was clicked: focus goes back to it on close */
      var flat = instant || motionOff();
      dlg.classList.remove('is-closing', 'is-open');
      dlg.classList.toggle('is-flat', !!flat);
      document.documentElement.classList.add('is-manifesto-open'); if (L.lock) { L.lock.lock('manifesto'); }
      dlg.showModal(); scroller.scrollTop = 0; fit(); dlg.classList.remove('has-turned'); pg = 0; paginate(); if (narrow.matches && !flat) { buildLeaf(); }
      jump(lift, flat ? { transform: '', opacity: '0' } : { transform: fromButton(), opacity: '0' });   /* after showModal: a hidden dialog has no start state */
      closeBtn.focus({ preventScroll: true });
      if (flat) { dlg.classList.add('is-open'); lift.style.opacity = ''; busy = false; return; }
      dlg.classList.add('is-animating');
      /* 1. Rise from the button (400 ms). */
      lift.style.transform = ''; lift.style.opacity = '';
      /* 2. Open the cover (900 ms); its shadow sweeps over the page and the cover darkens as it turns from the light. */
      later(function () {
        dlg.classList.add('is-open');
        if (shade.animate) {
          shade.animate([{ opacity: 0, transform: 'translateX(0)' }, { opacity: 1, offset: 0.3 }, { opacity: 0, transform: 'translateX(-40%)' }], { duration: 900, easing: 'ease-out' });
          shine.animate([{ opacity: 0 }, { opacity: 0.8, offset: 0.5 }, { opacity: 0.3 }], { duration: 900, easing: 'ease-in-out', fill: 'forwards' });
        }
      }, 400);
      later(function () { dlg.classList.remove('is-animating'); busy = false; }, 1320);
      if (narrow.matches) { later(peek, 1700); }
    }
    function close() {
      if (!dlg.open || dlg.classList.contains('is-closing')) { return; }
      busy = true; clearTimers(); drag = null; stopPeek(); if (turn) { leaf.classList.remove('is-on', 'is-settling'); turn = null; show(pg); }
      function done() {
        dlg.close(); dlg.classList.remove('is-closing', 'is-animating', 'is-open', 'is-flat');
        jump(lift, { transform: '', opacity: '' }); shine.style.opacity = '';
        document.documentElement.classList.remove('is-manifesto-open'); if (L.lock) { L.lock.unlock('manifesto'); }
        busy = false; if (opener && opener.focus) { opener.focus({ preventScroll: true }); }
      }
      dlg.classList.add('is-closing', 'is-animating');
      if (dlg.classList.contains('is-flat') || motionOff()) {
        dlg.classList.add('is-flat'); lift.style.opacity = '0'; later(done, 220); return;
      }
      /* 1. The cover swings shut (700 ms). */
      dlg.classList.remove('is-open');
      if (shine.animate) { shine.animate([{ opacity: 0.3 }, { opacity: 0.8, offset: 0.5 }, { opacity: 0 }], { duration: 700, easing: 'ease-in-out', fill: 'forwards' }); }
      /* 2. The closed book sinks back to the button and fades; the backdrop fades with it. */
      later(function () { lift.style.transform = fromButton(); lift.style.opacity = '0'; }, 700);
      later(done, 1100);
    }
    /* ---------- Phones: turning the pages ----------
       The text is laid out a page per column (CSS); `pg` is the page shown. A turn uses a leaf, a copy of the page built
       on the first open: forward, the leaf shows the current page and swings off round the spine while the next page is
       already underneath; back, it swings in from the left showing the previous page. It follows the finger while
       swiping (transform + the shade's opacity only), then settles. Arrows, a tap on the outer third of the page and the
       arrow keys turn too. To show that the page turns, the corner lifts once after opening and the bottom row says
       "Swipe to turn the page" until the first turn. Reduced motion: the page changes without the leaf. */
    var narrow = window.matchMedia('(max-width: 767px)');
    var paper = q('.mbook__page', dlg), flow = q('.manifesto__inner', scroller), count = q('[data-book-count]', dlg);
    var prevBtn = q('[data-book-prev]', dlg), nextBtn = q('[data-book-next]', dlg);
    var pg = 0, pages = 1, leaf = null, leafFlow = null, leafCount = null, leafShade = null, turn = null, drag = null;
    function setPage(el, n) { el.style.setProperty('--pg', n); }
    function label(n) { return (n + 1) + ' / ' + pages; }
    function paginate() {
      if (!narrow.matches) { pages = 1; pg = 0; setPage(flow, 0); return; }
      var last = flow.lastElementChild, w = paper.clientWidth;
      pages = last && w ? Math.max(1, Math.floor((last.getBoundingClientRect().right - 1 - flow.getBoundingClientRect().left) / w) + 1) : 1;
      show(Math.min(pg, pages - 1));
    }
    function show(n) {
      pg = n; setPage(flow, n); count.textContent = label(n);
      prevBtn.disabled = n <= 0; nextBtn.disabled = n >= pages - 1;
    }
    function buildLeaf() {
      if (leaf) { return; }
      leaf = document.createElement('div'); leaf.className = 'mbook__leaf'; leaf.setAttribute('aria-hidden', 'true'); leaf.inert = true;
      var front = paper.cloneNode(true);
      qa('[id], [tabindex], [aria-live]', front).forEach(function (el) { el.removeAttribute('id'); el.removeAttribute('tabindex'); el.removeAttribute('aria-live'); });
      leafFlow = q('.manifesto__inner', front); leafCount = q('[data-book-count]', front);
      qa('[data-book-shade]', front).forEach(function (el) { el.style.opacity = '0'; });
      qa('[data-book-prev], [data-book-next]', front).forEach(function (el) { el.removeAttribute('aria-label'); });
      leafShade = document.createElement('span'); leafShade.className = 'mbook__leaf-shade'; front.appendChild(leafShade);
      var back = document.createElement('div'); back.className = 'mbook__leaf-back';
      leaf.appendChild(front); leaf.appendChild(back); paper.parentNode.insertBefore(leaf, paper.nextSibling);
    }
    function angle(a) { leaf.style.transform = 'translateZ(0.5px) rotateY(' + a + 'deg)'; leafShade.style.opacity = String(Math.min(1, -a / 120)); }
    /* Start a turn (dir 1 = forward, -1 = back); false when there is no page that way. */
    function begin(dir) {
      var to = pg + dir;
      if (turn || to < 0 || to >= pages) { return false; }
      buildLeaf();
      var shown = dir > 0 ? pg : to;   /* the leaf carries the page that leaves (forward) or arrives (back) */
      setPage(leafFlow, shown); leafCount.textContent = label(shown);
      leaf.classList.add('is-on'); leaf.classList.remove('is-settling');
      angle(dir > 0 ? 0 : -180);
      if (dir > 0) { setPage(flow, to); }   /* the next page is already underneath */
      turn = { dir: dir, to: to };
      return true;
    }
    function settle(done) {
      var t = turn; if (!t) { return; }
      void leaf.offsetWidth; leaf.classList.add('is-settling');
      angle(t.dir > 0 ? (done ? -180 : 0) : (done ? 0 : -180));
      later(function () {
        leaf.classList.remove('is-on', 'is-settling'); turn = null;
        if (done) { show(t.to); dlg.classList.add('has-turned'); } else { show(pg); }
      }, 580);
    }
    function go(dir) {
      stopPeek();
      if (turn || pg + dir < 0 || pg + dir >= pages) { return; }
      if (dlg.classList.contains('is-flat') || motionOff()) { show(pg + dir); dlg.classList.add('has-turned'); return; }
      if (begin(dir)) { settle(true); }
    }
    /* The corner lifts and falls back once, a moment after the book has opened. */
    function peek() {
      if (!dlg.open || turn || drag || pg !== 0 || pages < 2 || dlg.classList.contains('has-turned') || !leaf || !leaf.animate) { return; }
      begin(1); turn.peek = true;
      var a = leaf.animate([{ transform: 'translateZ(0.5px) rotateY(0deg)' }, { transform: 'translateZ(0.5px) rotateY(-32deg)', offset: 0.45 }, { transform: 'translateZ(0.5px) rotateY(0deg)' }], { duration: 1200, easing: 'ease-in-out' });
      a.onfinish = a.oncancel = stopPeek;
    }
    function stopPeek() {
      if (!turn || !turn.peek) { return; }
      leaf.getAnimations().forEach(function (a) { a.onfinish = a.oncancel = null; a.cancel(); });
      leaf.classList.remove('is-on'); turn = null; show(pg);
    }
    paper.addEventListener('pointerdown', function (e) {
      if (!narrow.matches || e.button > 0 || e.target.closest('button')) { return; }
      stopPeek(); if (turn) { return; }
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: e.timeStamp, on: false, dir: 0, p: 0, v: 0 };
    });
    paper.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) { return; }
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y, w = paper.clientWidth;
      if (!drag.on) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) { return; }
        if (dlg.classList.contains('is-flat') || motionOff()) { drag = null; go(dx < 0 ? 1 : -1); return; }
        if (!begin(dx < 0 ? 1 : -1)) { drag = null; return; }
        drag.on = true; drag.dir = turn.dir;
        try { paper.setPointerCapture(e.pointerId); } catch (err) { /* already released */ }
      }
      var p = Math.max(0, Math.min(1, (drag.dir > 0 ? -dx : dx) / w));
      drag.v = (p - drag.p) / Math.max(1, e.timeStamp - drag.t); drag.p = p; drag.t = e.timeStamp;
      angle(drag.dir > 0 ? -180 * p : -180 * (1 - p));
    });
    function release(e) {
      if (!drag || e.pointerId !== drag.id) { return; }
      var d = drag; drag = null;
      if (d.on) { settle(e.type !== 'pointercancel' && (d.p > 0.3 || d.v > 0.0015)); return; }
      if (e.type !== 'pointerup' || Math.abs(e.clientX - d.x) > 8 || Math.abs(e.clientY - d.y) > 8) { return; }
      var r = paper.getBoundingClientRect(), x = (e.clientX - r.left) / r.width;   /* a tap on the outer third turns */
      if (x > 0.67) { go(1); } else if (x < 0.33) { go(-1); }
    }
    paper.addEventListener('pointerup', release);
    paper.addEventListener('pointercancel', release);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    dlg.addEventListener('keydown', function (e) {
      if (!narrow.matches || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) { return; }
      e.preventDefault(); go(e.key === 'ArrowRight' ? 1 : -1);
    });
    window.addEventListener('resize', function () { if (dlg.open) { paginate(); } });
    qa('[data-manifesto-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var go = function () { open(false, b); };
        Promise.race([preload(), new Promise(function (r) { setTimeout(r, 300); })]).then(go);   /* the cover is usually cached by then */
      });
      ['pointerenter', 'pointerdown', 'touchstart', 'focus'].forEach(function (t) { b.addEventListener(t, preload, { passive: true, once: true }); });
    });
    closeBtn.addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.hasAttribute('data-book-stage') || e.target === lift) { close(); } });   // the backdrop
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });        // Esc (native)
    dlg.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); } });
    /* If the browser closes it on its own (it may ignore a prevented cancel), tidy up the page state. */
    dlg.addEventListener('close', function () { if (busy) { return; } clearTimers(); dlg.classList.remove('is-closing', 'is-animating', 'is-open', 'is-flat'); jump(lift, { transform: '', opacity: '' }); document.documentElement.classList.remove('is-manifesto-open'); if (L.lock) { L.lock.unlock('manifesto'); } });
    dlg.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') { return; }
      var f = [closeBtn, scroller].concat(narrow.matches ? [prevBtn, nextBtn].filter(function (b) { return !b.disabled; }) : []), i = f.indexOf(document.activeElement);
      e.preventDefault(); f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus({ preventScroll: true });
    });
    document.addEventListener('lagom:panel', function (e) { if (e.detail !== 'manifesto' && dlg.open) { close(); } });
    if (location.hash === '#manifesto') { preload(); opener = q('[data-manifesto-open]'); open(true); }
  })();

})();
